"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spinnerSize = exports.progressBarSize = void 0;
exports.progressBarSize = {
    small: 'small',
    default: 'default',
    large: 'large',
};
exports.spinnerSize = {
    small: 'small',
    default: 'default',
    large2x: 'large2x',
};
